import {
  AppShell,
  NavigationList,
  NavigationListItem,
} from '@all-manager/design-system-v2';
import { Outlet } from 'react-router-dom';
import { APP_TITLE } from '../../constants/app';
import BrandLogo from '../BrandLogo/BrandLogo';
import NotificationsBell from '../../features/notifications/components/NotificationsBell/NotificationsBell';
import OnboardingDialog from '../../features/onboarding/components/OnboardingDialog/OnboardingDialog';
import GlobalSearchModal from '../../features/search/components/GlobalSearchModal/GlobalSearchModal';
import { useLayout } from './useLayout';

export default function Layout() {
  const hook = useLayout();
  const settingsEntry = hook.settingsEntry;

  return (
    <>
      <AppShell
        brand={{ name: APP_TITLE, logo: <BrandLogo /> }}
        title={hook.spaceName}
        switchSpace={hook.switchSpace}
        navigation={hook.groups.map((group) => (
          <NavigationList key={group.title} title={group.title}>
            {group.entries.map((entry) => (
              <NavigationListItem
                key={entry.path}
                label={entry.label}
                href={entry.path}
                icon={<entry.Icon />}
                selected={entry.selected}
                onClick={(event) => hook.handleLinkClick(event, entry.path)}
              />
            ))}
          </NavigationList>
        ))}
        actions={<NotificationsBell />}
        search={{
          label: 'Rechercher',
          onOpen: hook.search.handleOpen,
          shortcutHint: hook.search.shortcutHint,
          ariaKeyShortcuts: hook.search.ariaKeyShortcuts
        }}
        assistant={hook.assistant}
        footer={settingsEntry ? (
          <NavigationList>
            <NavigationListItem
              label={settingsEntry.label}
              href={settingsEntry.path}
              icon={<settingsEntry.Icon />}
              selected={settingsEntry.selected}
              alert={hook.driveAlert}
              onClick={(event) => hook.handleLinkClick(event, settingsEntry.path)}
            />
          </NavigationList>
        ) : undefined}
        account={hook.account}
      >
        <Outlet />
      </AppShell>

      <GlobalSearchModal isOpen={hook.search.isOpen} onClose={hook.search.handleClose} />
      <OnboardingDialog />
    </>
  );
}
